export default __webpack_public_path__ + "static/mob-img03-b9697722d335c3a7b04760adae41978f.png";